import { render, staticRenderFns } from "./carteiras.vue?vue&type=template&id=02e216a6"
import script from "./carteiras.vue?vue&type=script&lang=js"
export * from "./carteiras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports